<template>
  <div class="p-0 m-0">
    <Libre />
  </div>
</template>

<script>
import Libre from './components/Libre.vue'

export default {
  name: 'App',
  components: {
    Libre
  }
}
</script>
